import { render, staticRenderFns } from "./UsersBySimCount.vue?vue&type=template&id=6aaa4a25&"
import script from "./UsersBySimCount.vue?vue&type=script&lang=js&"
export * from "./UsersBySimCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports